<template>
  <div>
    <forum-thread-item
      ref="forumThreadItem"
      :thread="thread"
      :user-thread="thread.user"
      :learning-unit="learningUnit"
      class="container__comment"
      @reply:success="handleNewThreadReply"
    >
    </forum-thread-item>

    <forum-thread-item
      v-for="reply in replies"
      :key="`thread_${thread.id}_reply_${reply.id}`"
      ref="replyThreadItem"
      :thread="reply"
      :user-thread="reply.user"
      :learning-unit="learningUnit"
      class="container__comment reply-indent"
    >
    </forum-thread-item>

    <b-button
      v-if="isShowLoadMore"
      ref="btn__load-more"
      variant="link"
      class="load-more-reply text-primary py-2"
      @click.prevent="onLoadMoreClick"
      >View more replies</b-button
    >
  </div>
</template>

<script>
// import Forum from '@/models/Forum';
import ForumThreads from '@/models/ForumThreads';
import ForumThreadItem from './ForumThreadItem.vue';
import LearningUnit from '@/models/LearningUnit';
import Forum from '@/models/Forum';
export default {
  components: {
    ForumThreadItem
  },
  props: {
    thread: {
      type: ForumThreads,
      required: true
    },
    learningUnit: {
      type: LearningUnit,
      required: true
    }
  },
  data() {
    return {
      replyThreads: [],
      total: 0,
      filter: {
        startAt: null,
        endAt: null,
        chuckIndex: 0,
        limit: 2,
        sort: 'asc'
      }
    };
  },

  computed: {
    isShowLoadMore() {
      return this.replyThreads.length < this.total;
    },
    replies() {
      return this.replyThreads
        .map((thread) =>
          ForumThreads.query().with('user').with('liked').where('id', thread.id).first()
        )
        .filter(Boolean);
    }
  },

  async mounted() {
    await this.fetchRepliesMeta();

    await this.fetchThreads();
  },

  methods: {
    async onLoadMoreClick() {
      this.filter.chuckIndex += 1;

      await this.fetchThreads();
    },
    async fetchRepliesMeta() {
      const { response } = await ForumThreads.api().fetchReplyThreadsMeta(this.thread.id);

      if (response.data?.total) {
        this.total = response.data?.total;
      }
      if (response.data?.startAt) {
        this.filter.startAt = response.data.startAt.id;
      }
      if (response.data?.endAt) {
        this.filter.endAt = response.data.endAt.id;
      }
    },
    async fetchThreads() {
      const { response } = await ForumThreads.api().fetchReplyThreads(
        this.thread.id,
        this.filter.startAt,
        this.filter.endAt,
        this.filter.chuckIndex,
        this.filter.limit,
        this.filter.sort
      );

      if (response.data.length > 0) {
        this.replyThreads.push(...response.data);
      }
    },

    async handleNewThreadReply(newForumThread) {
      // should change to the same format as response data in fetch!
      this.replyThreads.unshift(newForumThread);

      // update main thread data
      await ForumThreads.api().getForumThreadById(
        newForumThread.forum_id,
        newForumThread.main_forum_thread_id
      );

      // update forum data
      await Forum.api().fetchById(newForumThread.forum_id);
    }
  }
};
</script>

<style lang="scss" scoped>
.content-indent {
  border-left: 1px solid var(--gray);
  margin-left: 22px;
  padding-left: 34px;
}
.reply-indent {
  border-left: 1px solid var(--gray);
  margin-left: 22px;
  padding-left: 20px;
}
.load-more-reply {
  padding: 1.25rem 3rem;
  color: #007bff;
}

.load-more-reply > a {
  color: #007bff;
  cursor: pointer;
}

.load-more-reply > a:hover {
  text-decoration: underline;
}
</style>
